import React from "react";
import { Pie } from "./Pie";
import { Bar } from "./Bar";

// import PurchaseList from "./PurchaseList";

export function Right() {
    return (
        <div className="home-right-box">
            <Pie />
            <Bar />
        </div>
    )
} 